import { AnalyticsClient } from '@modernhealth/web-analytics';

export const analyticsClient = new AnalyticsClient('provider-dash-web');
